import { createFeatureSelector, createSelector } from "@ngrx/store";
import { entityAdapter, EntityState } from "./entity.state";
import {Components, Entity} from "./entity.model";
import { Dictionary } from "@ngrx/entity";
import {ImageProperties} from "./component-properties-dto/images.properties.dto";
import {ReactionProperties} from "./component-properties-dto/reactions.properties.dto";
import {selectChatState} from "../chats/chat.selector";
import { UsersTrackProperties} from "./component-properties-dto/users-track.properties.dto";

export const selectEntityState =
    createFeatureSelector<EntityState>("entity");

export const { selectIds, selectEntities, selectAll, selectTotal }
    = entityAdapter.getSelectors(
      createSelector(selectEntityState, s => s)
  );

export const selectEntityById = (props: { entityId: string }) =>
  createSelector(selectEntities, (entities: Dictionary<Entity>) => {
    return entities[props.entityId] ?? null;
  });
export const selectEntityById2 = (props: { entityId: string }) =>
  createSelector(selectEntityState, (entityState: EntityState) => {
    return entityState.entities[props.entityId];
  });


// 3. Generic component property selector
export const selectComponentProperty = <T = any>(
    entityId: string,
    component: Components
) =>
    createSelector(
        selectEntityById({entityId: entityId}),
        (entity): T | undefined => entity?.componentProperties[component]
    );

// 4. Specific typed selectors for each component type
export const selectTextComponent = (entityId: string) =>
    createSelector(
        selectEntityById({entityId: entityId}),
        (entity): string | undefined =>
            entity?.componentProperties[Components.text]
    );

export const selectImageComponent = (entityId: string) =>
    createSelector(
        selectEntityById({entityId: entityId}),
        (entity): ImageProperties[] | undefined =>
            entity?.componentProperties[Components.images]
    );

export const selectReactionsComponent = (entityId: string) =>
    createSelector(
        selectEntityById({entityId: entityId}),
        (entity): ReactionProperties | undefined =>
            entity?.componentProperties[Components.reactions]
    );


export const selectUsersTrackComponent = (entityId: string) =>
    createSelector(
        selectEntityById({entityId: entityId}),
        (entity): UsersTrackProperties | undefined =>
            entity?.componentProperties[Components.usersTrack]
    );
